import { FormValues } from "./types";

const CLOSE_ACCOUNT_WAIVER = 40; // This was agreed by product and operation team

const PAGES = {
  LANDING: "LANDING",
  CAN_CLOSE: "CAN_CLOSE",
  CANT_CLOSE: "CANT_CLOSE",
  IN_PROGRESS: "IN_PROGRESS",
  FORM: "FORM",
  SUCCESS: "SUCCESS",
};

const emptyFormValues: FormValues = {
  reason: "",
  otherInfo: "",
  email: "",
  firstName: "",
  lastName: "",
  dateOfBirth: {
    day: "",
    month: "",
    year: "",
  },
  mobileNumber: "",
  confirmationLetter: false,
};

const initialCloseAccountState = {
  page: PAGES.LANDING,
  accountInfo: null,
  formValues: emptyFormValues,
};

function closeAccountReducer(state, action) {
  switch (state.page) {
    case PAGES.LANDING: {
      switch (action.type) {
        case "ACCOUNT_INFO_LOADED": {
          return {
            ...state,
            page:
              action.accountInfo.creditLimit -
                action.accountInfo.availableBalance <=
              CLOSE_ACCOUNT_WAIVER
                ? PAGES.CAN_CLOSE
                : PAGES.CANT_CLOSE,
            accountInfo: action.accountInfo,
            formValues: {
              ...state.formValues,
              email: action.accountInfo.userEmail ?? "",
            },
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.CAN_CLOSE: {
      switch (action.type) {
        case "START_REQUEST_CLICKED": {
          return {
            ...state,
            page: PAGES.FORM,
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.FORM: {
      switch (action.type) {
        case "CLOSE_ACCOUNT_SUCCEEDED": {
          return {
            ...state,
            page: PAGES.SUCCESS,
            formValues: action.formValues,
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
}

export { PAGES, initialCloseAccountState, closeAccountReducer };
